<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div
  class="d-flex justify-content-center align-items-center"
  style="background-color: #f8f4f4; width: 100%"
>
  <div
    class="p-4 shadow"
    style="margin-bottom: 40px; background-color: white; width: 100%"
  >
    <h1 class="text-center">Model</h1>

    <!-- Show Models or Selected Model -->
    <ng-container *ngIf="!selectedModelId">
      <h3 class="text-center mt-5">Ranges</h3>
      <p class="text-center">
        Once you have selected the Model/Style, only the available
        Options/Accessories for that Model/Style will be able to be selected.
      </p>

      <!-- Group models by 'group' property -->
      <ng-container
        *ngFor="
          let groupName of objectKeys(groupModelsByGroup(models));
          let i = index
        "
      >
        <div class="group-container">
          <!-- Check if the group has exactly 2 items -->
          <div
            [ngClass]="
              groupModelsByGroup(models)[groupName].length === 2
                ? 'd-flex justify-content-between two-item-group'
                : 'd-flex justify-content-around flex-wrap'
            "
          >
            <ng-container
              *ngFor="let model of groupModelsByGroup(models)[groupName]"
            >
                <div class="model-item-container">
                <button
                  class="model-item text-center c-pointer"
                  (click)="onSelectModel(model.modelId)"
                >
                  <img
                    [src]="model.imageUrl.startsWith('https://') ? model.imageUrl : '../../../assets/images/models/' + model.imageUrl"
                    alt="{{ model.name }}"
                    class="model-img"
                  />
                  <span>{{ model.name }}</span>
                </button>
              </div>
            </ng-container>
          </div>
          <!-- Conditionally display the <hr> for all groups except the last one -->
          <hr
            *ngIf="i < objectKeys(groupModelsByGroup(models)).length - 1"
            style="color: black; opacity: 1"
          />
        </div>
      </ng-container>
    </ng-container>

    <!-- If a model is selected -->
    <ng-container *ngIf="selectedModelId">
      <div class="d-flex justify-content-center align-items-center">
        <h3 class="text-center">Ranges</h3>
        <button class="btn-arrow" (click)="goBackToModelSelection()">
          <img
            src="../../../assets/chevron-down.png"
            alt="Back"
            style="width: 24px"
          />
        </button>
      </div>
      <div class="text-center mt-4">
        <button
          class="btn-product active"
          style="border-radius: 5px; background-color: #00b4e6; color: white"
        >
          {{ getSelectedModelName() }}
        </button>
      </div>
    </ng-container>
  </div>
</div>

<!-- Configuration Section -->
@if (selectedModelId) {
  <div
    class="d-flex justify-content-center align-items-center"
    style="background-color: #f8f4f4; width: 100%"
  >
    <div
      class="p-4 shadow"
      style="margin-bottom: 40px; background-color: white; width: 100%"
    >
      <!-- Configuration Form -->
      <form [formGroup]="configurationForm">
        <!-- Render filteredAttributes -->
        <ng-container *ngIf="filteredAttributes.length > 0">
          <ng-container *ngFor="let attribute of filteredAttributes">
            <ng-container *ngIf="!attribute.isHidden">
              <div
                class="form-group custom-select-wrapper"
                [class.disabled]="!attribute.isEnable"
              >
                <label [for]="attribute.name">{{ attribute.name }}</label>

                @if(attribute.helpText) {
                  <div
                    class="help-text"
                    style="display: block; width: 100%; font-size: 0.9em; color: #6c757d; margin-top: 2px;"
                    [attr.title]="attribute.helpText"
                    tabindex="0"
                  >
                    <span style="display: inline-flex">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        style="margin-right: 4px;"
                        class="icon icon-tabler icons-tabler-outline icon-tabler-help"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                        <path d="M12 17l0 .01" />
                        <path d="M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4" />
                      </svg>
                        <span style="padding-bottom: 4px;">
                        {{ attribute.helpText }}
                        </span>
                    </span>
                  </div>
                }

                <div *ngIf="isBothSelected && attribute.name === filteredAttributes[0].name" style="display: flex;">
                  <div class="attribute-name" style="color: #e53935;">
                    For ankle pads inside + outside orders, please contact customer services.
                  </div>
                </div>

                <!-- Select Component -->
                <ng-container *ngIf="attribute.componentType === 'Select'">
                  <div class="select-row">
                    <select
                      class="custom-select"
                      #selectElement
                      (change)="
                        onSelectValue(
                          attribute.attributeOptionId,
                          +selectElement.value
                        )
                      "
                      [class.disabled]="!attribute.isEnable"
                      [class.is-invalid]="
                        isFieldInvalid(attribute.attributeOptionId)
                      "
                      [formControlName]="attribute.attributeOptionId"
                    >
                      <option [value]="-1">
                        {{ getDefaultSelectValue(attribute.values) }}
                      </option>

                      @for (value of attribute.values; track value) {
                        @if (value.isVisible) {
                          <option
                            [class.disabled-input]="!value.isEnable"
                            [disabled]="!value.isEnable"
                            [value]="value.valueId"
                          >
                            {{ value.value }}
                          </option>
                        }
                      }
                      <option *ngIf="!attribute.values.length">
                        No values available
                      </option>
                    </select>
                  </div>
                </ng-container>

                <!-- CheckBox or RadioButton Component -->
               <ng-container
  *ngIf="
    attribute.componentType === 'CheckBox' ||
    attribute.componentType === 'RadioButton'
  "
>
  <div class="options-container">
    @for (
      value of attribute.values;
      track value;
      let i = $index
    ) {
      @if (value.isVisible) {
        <label
          [class.disabled-input]="!value.isEnable"
          class="custom-option"
        >
          <fieldset
            *ngIf="value.isVisible"
            style="width: 100%; text-align: center"
            [disabled]="!value.isEnable"
          >
            <!-- MUDANÇA IMPORTANTE AQUI -->
            <input
              *ngIf="attribute.componentType === 'CheckBox'"
              type="checkbox"
              [value]="value.valueId"
              [checked]="value.selectedValue"
              (change)="onCheckboxChange(attribute.attributeOptionId, value.valueId, $event)"
              [disabled]="!value.isEnable"
              [class.is-invalid]="isFieldInvalid(attribute.attributeOptionId)"
            />
            
            <input
              *ngIf="attribute.componentType === 'RadioButton'"
              type="radio"
              [value]="value.valueId"
              [checked]="value.selectedValue"
              (change)="onSelectValue(attribute.attributeOptionId, value.valueId)"
              [name]="attribute.attributeOptionId"
              [disabled]="!value.isEnable"
              [class.is-invalid]="isFieldInvalid(attribute.attributeOptionId)"
              [formControlName]="attribute.attributeOptionId"
            />
            
            <span
              [class.disabled-input]="!value.isEnable"
              style="display: block"
              class="checkbox-item"
            >{{ value.value }}</span>
          </fieldset>
        </label>
      }
    }
  </div>
</ng-container>

                <!-- New Text Component -->
                <ng-container *ngIf="attribute.componentType === 'Text'">
                  <div class="text-row">
                    <input
                      type="text"
                      class="form-control"
                      [disabled]="!attribute.isEnable"
                      [value]="attribute.selectedValue"
                      [class.is-invalid]="
                        isFieldInvalid(attribute.attributeOptionId)
                      "
                      [formControlName]="attribute.attributeOptionId"
                      (input)="
                        onTextValueChange(attribute.attributeOptionId, $event)
                      "
                    />
                    <div
                      *ngIf="isFieldInvalid(attribute.attributeOptionId)"
                      class="invalid-feedback"
                    >
                      <!-- {{ getErrorMessage(attribute.attributeOptionId) }} -->
                    </div>
                  </div>
                </ng-container>

                <!-- Validation Error Message -->
                <div
                  *ngIf="isFieldInvalid(attribute.attributeOptionId)"
                  class="invalid-feedback"
                >
                  {{ attribute.name }} is required.
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <h1 class="text-center">Options/Accessories</h1>

        <!-- Render filteredOptions -->
        <ng-container *ngIf="filteredOptions.length > 0">
          <ng-container *ngFor="let option of filteredOptions">
            <ng-container *ngIf="!option.isHidden">
              <div
                class="form-group custom-select-wrapper"
                [class.disabled]="!option.isEnable"
              >
                <label [for]="option.name">{{ option.name }}</label>

                @if(option.helpText) {
                  <div
                    class="help-text"
                    style="display: block; width: 100%; font-size: 0.9em; color: #6c757d; margin-top: 2px;"
                    [attr.title]="option.helpText"
                    tabindex="0"
                  >
                    <span style="display: inline-flex">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        style="margin-right: 4px;"
                        class="icon icon-tabler icons-tabler-outline icon-tabler-help"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                        <path d="M12 17l0 .01" />
                        <path d="M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4" />
                      </svg>
                        <span style="padding-bottom: 4px;">
                        {{ option.helpText }}
                        </span>
                    </span>
                  </div>
                }

                <!-- Select Component -->
                <ng-container *ngIf="option.componentType === 'Select'">
                  <div class="select-row">
                    <select
                      class="custom-select"
                      #selectOptionElement
                      (change)="
                        onSelectOptionValue(
                          option.attributeOptionId,
                          +selectOptionElement.value
                        )
                      "
                      [class.disabled]="!option.isEnable"
                      [class.is-invalid]="
                        isFieldInvalid(option.attributeOptionId)
                      "
                      [formControlName]="option.attributeOptionId"
                    >
                      <option [value]="-1">
                        {{ getDefaultSelectValue(option.values) }}
                      </option>

                      @for (value of option.values; track value) {
                        @if (value.isVisible) {
                          <option
                            [class.disabled-input]="!value.isEnable"
                            [disabled]="!value.isEnable"
                            [value]="value.valueId"
                          >
                            {{ value.value }}
                          </option>
                        }
                      }

                      <option *ngIf="!option.values.length">
                        No values available
                      </option>
                    </select>
                  </div>
                </ng-container>

                <!-- CheckBox or RadioButton Component -->
               <ng-container
  *ngIf="
    option.componentType === 'CheckBox' ||
    option.componentType === 'RadioButton'
  "
>
  <div class="options-container">
    @for (value of option.values; track value; let i = $index) {
      @if (value.isVisible) {
        <label
          [class.disabled-input]="!value.isEnable"
          class="custom-option"
        >
          <fieldset
            *ngIf="value.isVisible"
            style="width: 100%; text-align: center"
            [disabled]="!value.isEnable"
          >
            <!-- MUDANÇA IMPORTANTE AQUI TAMBÉM -->
            <input
              *ngIf="option.componentType === 'CheckBox'"
              type="checkbox"
              [value]="value.valueId"
              [checked]="value.selectedValue"
              (change)="onCheckboxChange(option.attributeOptionId, value.valueId, $event)"
              [disabled]="!value.isEnable"
              [class.is-invalid]="isFieldInvalid(option.attributeOptionId)"
            />
            
            <input
              *ngIf="option.componentType === 'RadioButton'"
              type="radio"
              [value]="value.valueId"
              [checked]="value.selectedValue"
              (change)="onSelectOptionValue(option.attributeOptionId, value.valueId)"
              [name]="option.attributeOptionId"
              [disabled]="!value.isEnable"
              [class.is-invalid]="isFieldInvalid(option.attributeOptionId)"
              [formControlName]="option.attributeOptionId"
            />
            
            <span
              [class.disabled-input]="!value.isEnable"
              style="display: block"
              class="checkbox-item"
            >{{ value.value }}</span>
          </fieldset>
        </label>
      }
    }
  </div>
</ng-container>

                <!-- New Text Component -->
                <ng-container *ngIf="option.componentType === 'Text'">
                  <div class="text-row">
                    <input
                      type="text"
                      class="form-control"
                      [disabled]="!option.isEnable"
                      [value]="option.selectedValue"
                      [class.is-invalid]="
                        isFieldInvalid(option.attributeOptionId)
                      "
                      [formControlName]="option.attributeOptionId"
                      (input)="
                        onTextValueChange(option.attributeOptionId, $event)
                      "
                    />
                    <div
                      *ngIf="isFieldInvalid(option.attributeOptionId)"
                      class="invalid-feedback"
                    >
                      <!-- {{ getErrorMessage(attribute.attributeOptionId) }} -->
                    </div>
                  </div>
                </ng-container>

                <!-- Validation Error Message -->
                <div
                  *ngIf="isFieldInvalid(option.attributeOptionId)"
                  class="invalid-feedback"
                >
                  {{ option.name }} is required.
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>

        <!-- Handle No Attributes and No Options -->
        <ng-container
          *ngIf="!filteredAttributes.length && !filteredOptions.length"
        >
          <div>No attributes or options available</div>
        </ng-container>
      </form>
    </div>
  </div>
}
